/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ScrollAnimation } from "./ScrollAnimation";
import "./styles.css";

const ScrollRevealImage = (props) => {

    const component = props?.component;
    const richtext = component?.richtext;
    const image = component?.image;
    const settings = component?.settings;

    return (
        <div className="simplicity-scroll-reveal top-section">
            {image && (
                <>
                {/*<div*/}
                {/*    className={`simplicity-scroll-reveal-inner`}*/}
                {/*>*/}
                    <ScrollAnimation
                        image={image}
                        settings={settings}
                        richtext={richtext}
                    />

                    {/*<RichTextImage*/}
                    {/*    width={displayWidth}*/}
                    {/*    height={displayHeight}*/}
                    {/*    image={image}*/}
                    {/*    settings={settings}*/}
                    {/*    orientation={orientation}*/}
                    {/*/>*/}
                {/*</div>*/}
                </>
            )}
            {/*<div className="rich-text-wrap read-only">*/}
            {/*    <RichText richtext={richtext} />*/}
            {/*</div>*/}
        </div>
    );
};

ScrollRevealImage.displayName = "ScrollRevealImage";
export { ScrollRevealImage };
